export default __webpack_public_path__ + "static/media/avatar_7.c7628011.svg";